import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["text", "icon", "container"];

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textTarget.textContent.trim());
      this.showSuccess();
    } catch (err) {
      console.error("Failed to copy text: ", err);
      // Fallback for older browsers
      this.fallbackCopy();
    }
  }

  fallbackCopy() {
    const textArea = document.createElement("textarea");
    textArea.value = this.textTarget.textContent.trim();
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    this.showSuccess();
  }

  showSuccess() {
    // Update tooltip to show "Copied!"
    this.element.setAttribute("data-railsui-tooltip-content-value", "Copied!");

    // Store original icon HTML if not already stored
    if (!this.originalIcon) {
      this.originalIcon = this.iconTarget.innerHTML;
    }

    // Change icon to checkmark with green color
    this.iconTarget.innerHTML = `<svg class="size-4 text-green-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
    </svg>`;

    // Reset after 2 seconds
    setTimeout(() => {
      this.iconTarget.innerHTML = this.originalIcon;
      this.element.setAttribute(
        "data-railsui-tooltip-content-value",
        "Copy to clipboard"
      );
    }, 2000);
  }
}
